import { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [authUser, setAuthUser] = useState(() =>
    JSON.parse(sessionStorage.getItem("authUser"))
  );
  const [loading, setLoading] =useState(true);

  useEffect(() => {
    if (authUser) {
      sessionStorage.setItem("authUser", JSON.stringify(authUser));
      setLoading(false);
    }
  }, [authUser]);

  return (
    <AuthContext.Provider value={{ authUser, setAuthUser, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
